const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const STATE_KEYS = [
  'v',
  'userId',
  'displayName',
  'selectedNodeId',
  'editingNodeId',
];

export function normalizeAwarenessDisplayName(value) {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return normalized ? normalized.slice(0, 80) : null;
}

export function createAwarenessState({
  userId,
  displayName,
  selectedNodeId = null,
  editingNodeId = null,
}) {
  if (!UUID_PATTERN.test(userId || '')) return null;
  return {
    v: 1,
    userId,
    displayName: normalizeAwarenessDisplayName(displayName),
    selectedNodeId: UUID_PATTERN.test(selectedNodeId || '')
      ? selectedNodeId
      : null,
    editingNodeId: UUID_PATTERN.test(editingNodeId || '')
      ? editingNodeId
      : null,
  };
}

export function isCanonicalAwarenessState(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const keys = Object.keys(value).sort();
  if (
    keys.length !== STATE_KEYS.length
    || keys.some((key, index) => key !== [...STATE_KEYS].sort()[index])
  ) {
    return false;
  }
  return (
    value.v === 1
    && UUID_PATTERN.test(value.userId || '')
    && (
      value.displayName === null
      || (
        typeof value.displayName === 'string'
        && value.displayName.length > 0
        && value.displayName.length <= 80
      )
    )
    && (
      value.selectedNodeId === null
      || UUID_PATTERN.test(value.selectedNodeId || '')
    )
    && (
      value.editingNodeId === null
      || UUID_PATTERN.test(value.editingNodeId || '')
    )
  );
}

export function filterAwarenessStates(states) {
  if (!Array.isArray(states)) return [];
  return states.filter((entry) => {
    if (!Number.isSafeInteger(entry?.clientId)) return false;
    const { clientId: _clientId, ...state } = entry;
    return isCanonicalAwarenessState(state);
  });
}
